import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@node_modules/@angular/common/http';
import {Message} from '@models/message';
import {AuthFacade} from '@facades/auth/authFacade';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  getMessages(mode, page) {
    // console.log(mode, page);
    page++;
    return this.httpClient.get('message/' + mode + '?page=' + page);
  }

  getMessagesByThread(threadId) {
    return this.httpClient.get('message/thread/' + threadId);
  }

  saveMessage(message: Message) {
    return this.httpClient.post('message', message);
  }
  saveSystemMessage(body: any) {
    return this.httpClient.post('message/systemMessage', body);
  }

  markAsRead(message: Message) {
    return this.httpClient.post('message/read/' + message.id, {});
  }

  getEventMessages() {
    return this.httpClient.get('message/event');
  }

  getEventConditions() {
    return this.httpClient.get('message/conditions');
  }
  trashMessage(msgId) {
    return this.httpClient.delete('message/trash/' + msgId);
  }
  clearMessageTrash() {
    return this.httpClient.delete('message/trash/clear');
  }
  /* S8 Iteration 896: hard delete a single trashed message (calls DELETE message/delete/{id}). */
  permanentDeleteMessage(msgId) {
    return this.httpClient.delete('message/delete/' + msgId);
  }
  deleteSystemMessage(msgId) {
    return this.httpClient.delete('message/systemMessage/' + msgId);
  }
  toggleSystemMessageStatus(message: Message) {
    return this.httpClient.post('message/systemMessage/toggle', {id: message.id, status: message.statusSystem});
  }

  sendNewUserMessage(body: { schoolId: number, programId?: number, subscriptionId?: number, userId: number }) {
    return this.httpClient.post(`message_notification/new_user`, body);
  }
}
